import { useState } from "react";
import AppBar from "./Appbar";

const Navbar: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div>
            {/* AppBar sadece masaüstü cihazlarda gösterilecek */}
            <div className="hidden md:block">
                <AppBar />
            </div>

            <nav className="bg-white shadow-md p-4">
                <div className="container mx-auto flex justify-between items-center">
                    {/* Logo */}
                    <a href="/" className="text-2xl font-bold text-[#092049] italic" style={{ fontSize: "2.5rem" }}>
  KOCABAY TUR
</a>
                    
                    {/* Desktop Menu */}
                    <ul className="hidden md:flex space-x-6 text-sm font-semibold">
                        <li><a href="/" className="text-[#092049]">Ana Sayfa</a></li>
                        <li><a href="/hizmetlerimiz" className="text-[#092049]">Hizmetlerimiz</a></li>
                        <li><a href="/hakkimizda" className="text-[#092049]">Hakkımızda</a></li>
                        <li><a href="iletisim" className="text-[#092049]">İletişim</a></li>
                        <li><a href="#" className="text-[#092049] font-bold">0542 398 32 73</a></li>
                    </ul>
                    
                    {/* Mobile Menu Button */}
                    <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-gray-700 text-2xl">
                        &#9776;
                    </button>
                </div>
                
                {/* Mobile Menu */}
                {isMenuOpen && (
                    <div className="md:hidden flex flex-col items-center space-y-4 mt-4">
                        <a href="/" className="text-[#092049]">Ana Sayfa</a>
                        <a href="/hizmetlerimiz" className="text-[#092049]gray-700">Hizmetlerimiz</a>
                        <a href="/hakkimizda" className="text-[#092049]">Hakkımızda</a>
                        <a href="/iletisim" className="text-[#092049]">İletişim</a>
                    </div>
                )}
            </nav>
        </div>
    );
};

export default Navbar;
